module.exports = __webpack_public_path__ + "static/media/black_eye.14c6d79d.svg";